import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { history } from 'Redux/store';

import 'Features/BundleCategory/components/BundlePillFilters.scss';

const messages = defineMessages({
  allbundles: {
    id: 'bundlespillfilters.allbundles',
    defaultMessage: 'All',
  },
  games: {
    id: 'bundlespillfilters.games',
    defaultMessage: 'Games',
  },
  books: {
    id: 'bundlespillfilters.books',
    defaultMessage: 'Books',
  },
  software: {
    id: 'bundlespillfilters.software',
    defaultMessage: 'Software',
  },
});

const BundlePillFilters = ({
  intl: { formatMessage },
  liveDisplayTypes,
  currentBundleType,
  mobilePills,
}) => {
  const liveDisplayTypesArray = Object.keys(liveDisplayTypes);
  const [type, setType] = useState('/bundle');

  let options = [
    { name: formatMessage(messages.allbundles), link: '/bundle', type: 'allbundles', live: true },
    { name: formatMessage(messages.games), link: '/bundle/games', type: 'games', live: !!liveDisplayTypesArray.find(liveType => liveType === 'bundle') },
    { name: formatMessage(messages.books), link: '/bundle/books', type: 'books', live: !!liveDisplayTypesArray.find(liveType => liveType === 'book-bundle' || liveType === 'comic-bundle') },
    { name: formatMessage(messages.software), link: '/bundle/software', type: 'software', live: !!liveDisplayTypesArray.find(liveType => liveType === 'software-bundle' || liveType === 'elearning-bundle' || liveType === 'elearning' || liveType === 'audio-bundle' || liveType === 'video-bundle') },
  ];

  options = options.filter(option => option.live);

  const currentOption = options.find(o => o.type === currentBundleType);

  const PillFilter = option =>
    <Link className={`pill-filter-container ${currentBundleType === option.type ? 'selected' : ''}`} to={option.link} key={option.type}>
      {option.name}
    </Link>;

  const onChange = (linkValue) => {
    history.push(linkValue);
  };

  useEffect(() => {
    if (currentOption) setType(currentOption.link);
  }, [currentOption]);

  if (mobilePills) {
    return (
      <div className="bundle-pill-filters-container">
        {options.map(option => PillFilter(option))}
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="bundle-pill-filters-container d-none d-lg-flex">
        {options.map(option => PillFilter(option))}
      </div>

      <div className="filters-container d-block d-lg-none">
        <div className="mr-3"><FormattedMessage id="bundlepillfilters.type" defaultMessage="Type" />:</div>
        <div className="dropdown-container type-filter">
          <select value={type} onChange={e => onChange(e.target.value)}>
            {options.map(option =>
              <option
                key={option.type}
                value={option.link}
              >
                {formatMessage(messages[option.type])}
              </option>,
            )}
          </select>
        </div>
      </div>
    </React.Fragment>

  );
};

BundlePillFilters.propTypes = {
  liveDisplayTypes: PropTypes.shape({}),
  currentBundleType: PropTypes.string,
  mobilePills: PropTypes.bool,
};

BundlePillFilters.defaultProps = {
  liveDisplayTypes: {},
  currentBundleType: '',
  mobilePills: false,
};

const mapStateToProps = ({
  router: { location: { search } },
  liveDisplayTypes,

}) => ({
  search,
  liveDisplayTypes,
});

export default connect(mapStateToProps, null)(injectIntl(BundlePillFilters));
